import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EdgeRouterV2, NetworkV2 } from '@netfoundry-ui/shared/model';
import { NetworkUpgradeService } from '../network-upgrade.service';
import semver from 'semver';

@Component({
    selector: 'app-network-upgrade-modal',
    templateUrl: './network-upgrade-modal.component.html',
    styleUrls: ['./network-upgrade-modal.component.scss'],
    standalone: false
})
export class NetworkUpgradeModalComponent {
    title = 'Network Upgrade Available';
    icon = '';
    action = 'Upgrade Network';
    cancelAction = 'Oops, no get me out of here';
    upgradeMode: any;

    network: NetworkV2;
    versionList: any[];
    baseVersionList: any[];
    upgradeOptionList = [
        { label: 'Entire Network', value: 'all' },
        { label: 'Just my Network Controller(s)', value: 'nc' },
        { label: 'Network Controller(s) and Edge Router(s)', value: 'ncer' },
        { label: 'Just My Edge Router(s)', value: 'er' },
    ];
    edgeRouterList: any[] = [];
    selectedVersion = '';
    selectedUpgradeOption = this.upgradeOptionList[0];
    selectedEdgeRouters: EdgeRouterV2[] = [];
    currentZitiVersion: string;

    constructor(
        private dialogRef: MatDialogRef<NetworkUpgradeModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private networkUpgradeSvc: NetworkUpgradeService
    ) {
        this.network = data.network;
        this.baseVersionList = (this.network as any)['upgradeableVersions'];
        this.versionList = this.baseVersionList ? [...this.baseVersionList] : [];
        if (this.versionList) {
            this.versionList.sort((a, b) =>
                semver.compare(b.zitiVersion, a.zitiVersion)
            );
            for (const v of this.versionList) {
                if (v.recommended) {
                    this.selectedVersion = v.zitiVersion;
                }
            }
        }

        const currentProductVersion = this.network?.productVersion;
        if (currentProductVersion) {
            const currentVersionData = this.networkUpgradeSvc.networkVersions.find(
                v => v.networkVersion === currentProductVersion
            );
            this.currentZitiVersion = currentVersionData?.zitiVersion || currentProductVersion;
        }
    }

    optionSelected(option: string) {
        this.selectedUpgradeOption = this.upgradeOptionList.filter((o) => o.value === option)[0];

        if (option === 'er') {
            this.updateVersionListForEdgeRoutersOnly();
        } else {
            this.versionList = this.baseVersionList ? [...this.baseVersionList] : [];
            this.versionList.sort((a, b) =>
                semver.compare(b.zitiVersion, a.zitiVersion)
            );

            this.updateCurrentVersionDisplay();
        }

        if (option === 'ncer' || option === 'er') {
            this.networkUpgradeSvc
                .getEdgeRouters(this.network.id)
                .then((data) => {
                    this.edgeRouterList = data;
                })
                .catch((e) => {
                    throw e;
                });
        }
    }

    private updateVersionListForEdgeRoutersOnly() {
        this.versionList = this.baseVersionList ? [...this.baseVersionList] : [];

        const currentVersion = this.network.productVersion;
        const currentVersionExists = this.versionList.some(v => v.networkVersion === currentVersion);

        if (!currentVersionExists) {
            const allVersions = this.networkUpgradeSvc.networkVersions;
            const currentVersionData = allVersions.find(v => v.networkVersion === currentVersion);

            if (currentVersionData) {
                this.versionList.push(currentVersionData);
            }
        }

        this.versionList.sort((a, b) =>
            semver.compare(b.networkVersion, a.networkVersion)
        );
    }

    private updateCurrentVersionDisplay(productVersion?: string) {
        const versionToDisplay = productVersion || this.network?.productVersion;

        if (versionToDisplay) {
            const currentVersionData = this.networkUpgradeSvc.networkVersions.find(
                v => v.networkVersion === versionToDisplay
            );
            this.currentZitiVersion = currentVersionData?.zitiVersion || versionToDisplay;
        }
    }

    cancel() {
        this.dialogRef.close();
    }

    confirm() {
        const selectedVersion = this.versionList.find((o) => o.zitiVersion === this.selectedVersion)?.networkVersion;
        if (!this.selectedVersion) this.cancel()
        else if(this.selectedUpgradeOption.value === 'all') {
            const options: any = {
                network: this.network,
                upgradeVersion: selectedVersion,
            };
            options.upgradeMode= 'FULL'
            this.dialogRef.close(options)
        } else if(this.selectedUpgradeOption.value === 'nc') {
            const options: any = {
                network: this.network,
                upgradeVersion: selectedVersion,
            };
            options.upgradeMode = 'CONTROLLERS_ONLY'
            this.dialogRef.close(options)
        } else if(this.selectedUpgradeOption.value === 'ncer') {
            const options: any = {
                network: this.network,
                upgradeVersion: selectedVersion,
            };
            options.edgeRouterIds = this.selectedEdgeRouters.map((er) => er.id);
            options.upgradeMode = 'FULL';
            this.dialogRef.close(options)
        } else if (this.selectedUpgradeOption.value === 'er') {
            const options: any = {
                network: this.network,
                upgradeVersion: selectedVersion,
            };
            options.edgeRouterIds = this.selectedEdgeRouters.map((er) => er.id);
            options.upgradeMode = 'EDGE_ROUTERS_ONLY';
            this.dialogRef.close(options)
        }
    }
}
